export default __webpack_public_path__ + "static/media/28.9d5574ae.png";